export class JavaVulnerability {
  constructor(private readonly name: string, private readonly url: string | null) {}

  getName() {
    return this.name;
  }

  getUrl() {
    return this.url;
  }
}
